import { Modal } from 'antd'
import React from 'react'
import { isDesktop, isMobile, isTablet } from 'react-device-detect'
import { IconContext } from 'react-icons'
import { FiCheckCircle } from 'react-icons/fi'
import Button from '../Button'

interface ExistingEmailModalModalProps {
  isVisible: boolean
  onStartBeginning: () => void
  onStartFromLastAccessedPage: () => void
  onCancel: () => void
}

const ExistingEmailModal = ({
  isVisible,
  onStartBeginning,
  onStartFromLastAccessedPage,
  onCancel,
}: ExistingEmailModalModalProps) => {
  return (
    <>
      <Modal
        width={`${(isMobile || isTablet) && !isDesktop ? '90vw' : '50vw'}`}
        open={isVisible}
        centered
        footer={null}
        closable={false}
      >
        <div className="flex flex-col items-center py-4 md:py-4">
          <div className="text-5xl">
            <IconContext.Provider value={{ color: 'green' }}>
              <FiCheckCircle />
            </IconContext.Provider>
          </div>
          <div className="mt-4 text-center text-3xl font-semibold md:mt-4 md:text-4xl">
            We recognize your email address.
          </div>
          <div className="my-4 text-xl md:my-0 md:px-6 md:text-2xl">
            <div className="my-5 text-center">
              If you want to fill out the forms completely on your own, click "Continue" below.
            </div>
            <div className="my-5 text-center">
              If you would us to complete part of the forms for you, click “Go To Email” to have an email sent that you
              can click to have some of the form filled out for you.
            </div>
          </div>

          <div className="flex w-full justify-center gap-8 px-10 md:p-10 md:px-0">
            <div className="flex w-full flex-col items-center">
              <Button btnName={'Continue'} type="secondary" onClickHandler={onStartBeginning} />
            </div>
            <div className="flex w-full flex-col items-center">
              <Button btnName={'Go To Email'} btnType={'submit'} onClickHandler={onStartFromLastAccessedPage} />
            </div>
          </div>
        </div>
      </Modal>
    </>
  )
}

export default ExistingEmailModal
